import { render, staticRenderFns } from "./ghModelView.vue?vue&type=template&id=6f67fca8&scoped=true&"
import script from "./ghModelView.vue?vue&type=script&lang=js&"
export * from "./ghModelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67fca8",
  null
  
)

export default component.exports